import AOS from "aos";
import "aos/dist/aos.css";
import React, { useEffect, useState } from 'react';
import { Container } from "react-bootstrap";
import analytic from "../../../assets/icon/analytics.svg";
import development from "../../../assets/icon/development.svg";
import mobile from "../../../assets/icon/hand-graving-smartphone.svg";
import management from "../../../assets/icon/pencil.svg";
import website from "../../../assets/icon/web-browser.svg";
import ecommerce from "../../../assets/icon/web-maintenance.svg";
import ServiceCard from './ServiceCard/ServiceCard';


const services = [
  {
    image: website,
    title: "Web Development",
    text:
      "Looking to improve your page performance, SEO, or user experience? Request a free site audit.",
    id: 1
  },
  {
    image: mobile,
    title: "Android Development",
    text:
      "A responsive design makes your website accessible to all users, regardless of their device.",
    id:2
  },
  {
    image: analytic,
    title: "Analytic",
    text:
      "Get insights into who is browsing your site so that you can make smarter business decisions.",
    id:3
  },
  {
    image: management,
    title: "Content Management",
    text:
      "Custom WordPress theme and plugin development. Easily update content without knowing how to code.",
    id:4
  },
  {
    image: ecommerce,
    title: "E-commerce",
    text:
      "Integration of E-commerce platforms, payment gateways, custom product templates, and more.",
    id:5
  },
  {
    image: development,
    title: "Design and Development",
    text:
      "Clean, modern designs - optimized for performance, search engines, and converting users to customers.",
    id:6
  },
];

const Service = () => {
  const [manageService, setManageService] = useState(services);
  useEffect(() => {
    AOS.init({ duration: 2000 });
  }, []);
  return (

    <>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 220">
        <path
          fill="#100028"
          fillOpacity="1"
          d="M0,160L1440,96L1440,320L0,320Z"
        ></path>
      </svg>
      <div className="bg-color">
        <Container data-aos="fade-up"
     data-aos-duration="3000" id="service">

        <h1 style={{ color: "#ffffff" }} className="text-center mb-5 pt-3 pt-md-0 headline">
          SERVICE
        </h1>
        <ServiceCard services={manageService} />
      </Container>
      </div>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 220">
        <path
          fill="#100028"
          fillOpacity="1"
          d="M0,160L1440,96L1440,0L0,0Z"
        ></path>
      </svg>
    </>

    );
};

export default Service;